<template functional>
    <label class="text-dark font-weight-bold" :for="props.for">
        {{ props.text }}
    </label>
</template>

<script>
    export default {
        name: 'Label',
        functional: true,
        props: {
            text: {
                type: String,
                required: true
            },
            for: {
                type: String
            }
        }
    }
</script>